import { IGeneralLang } from '../../../types/lang'

export const generalLang: IGeneralLang = {
	general: {
		btn_filters_apply: 'Застосувати',
		react_select_placeholder: 'Виберіть...',
		react_select_no_options: 'Опції відсутні',
		react_select_create_label: 'Створити',
		header_language_label: 'Мова',
		total_label: 'Всього',
		table_no_data: 'Дані відсутні'
	}
}